module.exports = __webpack_public_path__ + "img/tr-cancel-icon.c006b437.svg";